module.exports = __webpack_public_path__ + "img/speaker-touming.30a9b481.svg";